<template>
    <div v-loading="loading">
        <hts-form-date
            v-model="filters.dateRange"
            range
            type="dateRange"
            prop="dateRange"
            :placeholder="$t('labels.fromTo')"
            class="max-w-96 max-h-96" />
        <div class="my-4">
            <h2>
                Khách hàng
            </h2>
            <hts-data-table
                class="w-full mt-4"
                :headers="headers"
                :items="items || []" />
        </div>
    </div>
</template>

<script setup lang="ts">
const { $formatters } = useNuxtApp()
const { reportPage } = $store()
const loading = ref(true)
const headers = [
  {
    field: 'name',
    headerName: $t('labels.nameCustomer')
  },
  {
    field: 'saleName',
    headerName: $t('labels.staffSale')
  },
  {
    field: 'distributionName',
    headerName: $t('labels.abstemious')
  },
  {
    field: 'haveContact',
    headerName: $t('labels.contract'),
    valueGetter: (params: any) => {
      const { haveContact } = params.data
      if (haveContact) {
        return $t('labels.true')
      }
      return $t('labels.false')
    }
  },
  {
    field: 'contractStatus',
    headerName: $t('labels.contractStatus'),
    valueGetter: (params: any) => {
      const { contractStatus, stopEffect, type } = params.data.contract
      let { effectiveDate, dueDate } = params.data

      if (typeof contractStatus !== 'number') {
        return ''
      }

      if (type !== 'CONTRACT') {
        return
      }

      effectiveDate = effectiveDate + ' 00:00:00'
      dueDate = dueDate + ' 23:59:59'

      if (stopEffect) {
        return $t('labels.stopEffect')
      }

      if (contractStatus === 0) {
        return $t('labels.notApprovedYet')
      }

      if (contractStatus === -1) {
        return $t('labels.refuse')
      }

      if (contractStatus === 1) {
        const now = new Date()
        if (effectiveDate && new Date(effectiveDate) > now) {
          return $t('labels.approved')
        }

        if (dueDate && new Date(dueDate) < now) {
          return $t('labels.outOfEffect')
        }

        return $t('labels.effect')
      }
    }
  },
  {
    field: 'totalOpportunity',
    headerName: $t('labels.businessOpportunity'),
    valueGetter: (params: any) => {
      const { totalOpportunity } = params.data
      return $formatters.formatNumber(totalOpportunity || 0)
    }
  },
  {
    field: 'totalProductivityOpportunity',
    headerName: $t('labels.businessOpportunityProductivity'),
    valueGetter: (params: any) => {
      const { totalProductivityOpportunity } = params.data
      return $formatters.formatNumber(totalProductivityOpportunity || 0)
    }
  },
  {
    field: 'totalQuote',
    headerName: $t('labels.quoteCount'),
    valueGetter: (params: any) => {
      const { totalQuote } = params.data
      return $formatters.formatNumber(totalQuote || 0)
    }
  },
  {
    field: 'totalOrder',
    headerName: $t('labels.orderCount'),
    valueGetter: (params: any) => {
      const { totalOrder } = params.data
      return $formatters.formatNumber(totalOrder || 0)
    }
  },
  {
    field: 'totalTrip',
    headerName: $t('labels.tripCount'),
    valueGetter: (params: any) => {
      const { totalTrip } = params.data
      return $formatters.formatNumber(totalTrip || 0)
    }
  },
  {
    field: 'revenue',
    headerName: $t('labels.revenue'),
    valueGetter: (params: any) => {
      const { revenue } = params.data
      return $formatters.formatNumber(revenue || 0)
    }
  },
  {
    field: 'cost',
    headerName: $t('labels.cost'),
    valueGetter: (params: any) => {
      const { cost } = params.data
      return $formatters.formatNumber(cost || 0)
    }
  },
  {
    field: 'profit',
    headerName: $t('labels.profit'),
    valueGetter: (params: any) => {
      const { profit } = params.data
      return `${$formatters.formatNumber(profit || 0)}`
    }
  },
  {
    field: 'tripProductivityOpportunityRate',
    headerName: $t('labels.tripRateBusinessOpportunitiesCount'),
    valueGetter: (params: any) => {
      const { totalTrip, totalProductivityOpportunity } = params.data
      if (!totalProductivityOpportunity) {
        return
      }
      return `${totalTrip}/${totalProductivityOpportunity}`
    }
  }
]
const items = ref<any[]>([])

const filters = computed({
  get () {
    return reportPage.filters
  },
  set (val: any) {
    reportPage.setFilters(val)
  }
})

onMounted(() => {
  getReport()
})

/** Watching */
watch(
  () => filters.value,
  (val: any) => {
    loadReport()
  },
  { deep: true }
)

/** API requests */
const getReport = () => {
  items.value = []
  $api($url.report.getCustomer, { body: filters.value })
    .then((data: any) => {
      const responseData: any = data.data.value
      if (responseData?.success) {
        items.value = responseData.data
      } else {
        items.value = []
      }
      loading.value = false
    })
    .catch(() => {
      loading.value = false
    })
}

const loadReport = $lodash.debounce(getReport, 500)
</script>
